import { Link } from "react-router-dom";
import { cx } from "class-variance-authority";
import { Users, BarChart3 } from "lucide-react";

export default function SidebarManager({ sidebarMinMax = false }) {
  return (
    <>
      <Link
        to={"/manager/service_engineer/dashboard"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <Users className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">
            Engineer Dashboard
          </span>
        )}
      </Link>
      <Link
        to={"/manager/logistic/dashboard"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <BarChart3 className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">
            Logistic Dashboard
          </span>
        )}
      </Link>
    </>
  );
}
